module.exports = __webpack_public_path__ + "static/media/socialMedia.1d361efb.png";